module.exports = __webpack_public_path__ + "media/opcionfin.96bc7584.mp3";